module.exports = __webpack_public_path__ + "static/success-failure-f21b123fe0553752e78d528ea7a5103b.jpg";